import React from 'react';
import SemanticPopup from 'semantic-ui-react/dist/es/modules/Popup/Popup';

export const Popup = ({ ...props }) => (
  <SemanticPopup inverted basic {...props} />
);
